export interface RelatedRowMeta {
  isRelated: boolean;
  relatedCount: number;
  relatedIndex: number;
  isFirstRelated: boolean;
  isLastRelated: boolean;
}

export interface RelatedRowInput {
  rowKey: string;
  catalogItemId: string | null | undefined;
}

const singleRowMeta: RelatedRowMeta = {
  isRelated: false,
  relatedCount: 1,
  relatedIndex: 0,
  isFirstRelated: true,
  isLastRelated: true
};

export function buildRelatedRowMeta(rows: RelatedRowInput[]): Record<string, RelatedRowMeta> {
  const groups = new Map<string, RelatedRowInput[]>();

  for (const row of rows) {
    if (!row.catalogItemId) continue;
    const group = groups.get(row.catalogItemId) ?? [];
    group.push(row);
    groups.set(row.catalogItemId, group);
  }

  const metaByKey: Record<string, RelatedRowMeta> = {};

  for (const row of rows) {
    metaByKey[row.rowKey] = singleRowMeta;
  }

  for (const group of groups.values()) {
    if (group.length <= 1) continue;
    group.forEach((row, index) => {
      metaByKey[row.rowKey] = {
        isRelated: true,
        relatedCount: group.length,
        relatedIndex: index,
        isFirstRelated: index === 0,
        isLastRelated: index === group.length - 1
      };
    });
  }

  return metaByKey;
}

export function relatedRowClass(meta: RelatedRowMeta | undefined): string {
  if (!meta?.isRelated) return "";
  return [
    "related-row",
    meta.isFirstRelated ? "related-row-first" : "",
    meta.isLastRelated ? "related-row-last" : ""
  ]
    .filter(Boolean)
    .join(" ");
}
